import React from 'react';

import { ColorSchema, ComponentSize } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { MatchStatusType } from '../../../typings/match';
import { getMatchState } from '../../../utils/match-status';
import { applyColorSchema, makeClassNames } from '../../../utils/styles';

import './result-label.scss';

export interface IResultLabel extends IComponent {
  itemState: MatchStatusType;
}

const classNames = (colorSchema: ColorSchema, size?: ComponentSize) =>
  makeClassNames({
    resultLabel: ['result-label', `${applyColorSchema('result-label', colorSchema)}`, size && `result-label--${size}`],
  });

const ResultLabel = ({ itemState, children = '0-0', colorSchema = 'light', size }: IResultLabel) => {
  const dataState = getMatchState(itemState);
  const cn = classNames(colorSchema, size);

  return (
    <span className={cn.resultLabel} data-state={dataState} data-size={size}>
      {children}
    </span>
  );
};

export default ResultLabel;
